import { useState } from "react";
import "./ContactForm.css";

function ContactForm() {
  const [result, setResult] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setResult("");

    const formData = new FormData(event.target);
    formData.append("access_key", process.env.REACT_APP_WEB3FORMS_KEY);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        setResult("success");
        event.target.reset();
      } else {
        setResult("error");
      }
    } catch {
      setResult("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <h1 className="contact-title">Get in Touch</h1>
      <form className="contact-form" onSubmit={onSubmit}>
        <label htmlFor="name">Name</label>
        <input type="text" name="name" id="name" required />

        <label htmlFor="email">Email</label>
        <input type="email" name="email" id="email" required />

        <label htmlFor="message">Message</label>
        <textarea name="message" id="message" rows="5" required></textarea>

        <button type="submit" disabled={submitting}>
          {submitting ? "Sending..." : "Send Message"}
        </button>

        {result === "success" && (
          <p className="form-result success">Message sent!</p>
        )}
        {result === "error" && (
          <p className="form-result error">
            Something went wrong. Please try again.
          </p>
        )}
      </form>
    </div>
  );
}

export default ContactForm;
